import { Component, input, output, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PendingInvoicesDataCard } from '../../interfaces/pending-invoices.interface';

@Component({
  selector: 'sura-pending-invoices-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './pending-invoices-card.component.html',
  styleUrl: './pending-invoices-card.component.scss',
})
export class PendingInvoicesCardComponent {
  // --- INPUTS ---
  cardData = input.required<PendingInvoicesDataCard>();
  isPaymentProcessing = input<boolean>(false);
  isChecked = input<boolean>(false);

  // --- OUTPUTS ---
  cardSelected = output<PendingInvoicesDataCard>();
  paymentRequested = output<PendingInvoicesDataCard>();

  // --- LÓGICA INTERNA ---
  statusClass = computed(() =>
    this.cardData().status === 'En riesgo de cancelación' ? 'danger' : 'available'
  );

  onCheckboxChange(): void {
    this.cardSelected.emit(this.cardData());
  }

  onPayment(): void {
    if (this.isChecked()) {
      console.log(`Procesando pago para card: ${this.cardData().id}`);
      this.paymentRequested.emit(this.cardData());
    }
  }
}
